import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import labels from "../../shared/labels";
import { type AuctionProduct } from "./types";


export default /*@__PURE__*/_defineComponent({
  __name: 'RedeemInfoBox',
  props: {
    product: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.product.redeemInfo != null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.$style['product-info-box'])
      }, [
        _createElementVNode("strong", null, _toDisplayString(_unref(labels).frontendProductpage.redeemInfoHeader), 1 /* TEXT */),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
        _createElementVNode("ul", {
          class: _normalizeClass(_ctx.$style['product-info-list'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.redeemInfo
                    .replace(/\r/g, '')
                    .split(/(^|\n)\s*[\*-\>●]\s*/g)
                    .filter((x) => x.trim().length > 0), (item) => {
            return (_openBlock(), _createElementBlock("li", null, _toDisplayString(item), 1 /* TEXT */))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _renderSlot(_ctx.$slots, "after-items")
        ], 2 /* CLASS */)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

})